
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"-19936.102 -13670.623 18.826 18.826"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('g',{attrs:{"id":"Symbol_4_1","data-name":"Symbol 4 – 1","transform":"translate(-19935.502 -13670.024)"}},[_c('g',{attrs:{"id":"Group_53","data-name":"Group 53","opacity":".87"}},[_c('circle',{staticClass:"cls-2",attrs:{"id":"Ellipse_13","cx":"8.813","cy":"8.813","r":"8.813","data-name":"Ellipse 13"}}),_c('path',{staticClass:"cls-2",attrs:{"id":"Line_16","d":"M0 0h2.072","data-name":"Line 16","transform":"translate(3.314 6.328)"}}),_c('path',{staticClass:"cls-2",attrs:{"id":"Line_17","d":"M0 0h2.034","data-name":"Line 17","transform":"translate(7.345 6.328)"}}),_c('path',{staticClass:"cls-2",attrs:{"id":"Path_83","d":"M12.2 17.8l2.825 6.554 2.034-4.254","data-name":"Path 83","transform":"translate(-7.982 -11.472)"}}),_c('path',{staticClass:"cls-2",attrs:{"id":"Path_84","d":"M22.6 15.607l2.825 6.441s2.147-4.444 2.486-5.5a2.377 2.377 0 0 0-1.055-2.448","data-name":"Path 84","transform":"translate(-14.464 -9.166)"}})])])])
          )
        }
      }
    